const en = {
  confirmSixMonths: 'After this second country change, your next change will be available in 6 months. Accept to continue.',
  confirmYear: 'After this country change, your next change will be available in 1 year. Accept to continue.',
  accept: 'I understand and accept',
  locked: 'You can change your country again on {{date}}.',
  confirmationNeeded: 'Accept the country-change conditions to continue.',
  policyUnavailable: 'Country changes are temporarily unavailable. Try again later.',
  locationDisabled: 'Location services are off. Enable them in your device settings or choose a country manually.',
  locationTimeout: 'Could not get your location in time. Try again or choose a country manually.',
  openSettings: 'Open location settings',
};
const ru = {
  confirmSixMonths: 'После этой, второй, смены страны следующая будет доступна через 6 месяцев. Примите условия, чтобы продолжить.',
  confirmYear: 'После этой смены страны следующая будет доступна через 1 год. Примите условия, чтобы продолжить.',
  accept: 'Понимаю и принимаю',
  locked: 'Сменить страну снова можно {{date}}.',
  confirmationNeeded: 'Примите условия смены страны, чтобы продолжить.',
  policyUnavailable: 'Смена страны временно недоступна. Попробуйте позже.',
  locationDisabled: 'Геолокация выключена. Включите её в настройках устройства или выберите страну вручную.',
  locationTimeout: 'Не удалось определить локацию за отведённое время. Повторите попытку или выберите страну вручную.',
  openSettings: 'Открыть настройки геолокации',
};
const zh = {
  confirmSixMonths: '本次为第二次更改国家。更改后需等待 6 个月才能再次更改。请接受条件以继续。',
  confirmYear: '本次更改国家后，需等待 1 年才能再次更改。请接受条件以继续。',
  accept: '我理解并接受', locked: '您可以在 {{date}} 再次更改国家。',
  confirmationNeeded: '请先接受更改国家的条件。', policyUnavailable: '暂时无法更改国家，请稍后重试。',
  locationDisabled: '定位服务已关闭。请在设备设置中开启，或手动选择国家。',
  locationTimeout: '定位超时。请重试或手动选择国家。', openSettings: '打开定位设置',
};
const translations = { en, ru, zh };
export default translations;
